'use client';

import { CoreEvent, eventNames } from '@carvana/core-events';
import AiSuggestionChip from '@carvana/ds-ai-suggestion-chip';
import { useCallback, useRef } from 'react';
import useComposerOpenReady from '~/hooks/common/composer/useComposerOpenReady';
import useComposerStarterQuestionTypewriter from '~/hooks/home/useComposerStarterQuestionTypewriter';

type OwnProps = {
  questions: ReadonlyArray<string>;
};

export default function HomeStarterQuestion({ questions }: OwnProps) {
  const { displayedText, targetQuestion } =
    useComposerStarterQuestionTypewriter(questions);
  const { isPending, whenReady } = useComposerOpenReady();
  const pinnedQuestionRef = useRef<string | null>(null);

  const handlePointerDown = useCallback(() => {
    pinnedQuestionRef.current = targetQuestion;
  }, [targetQuestion]);

  const handleClick = useCallback(() => {
    const question = pinnedQuestionRef.current ?? targetQuestion;
    pinnedQuestionRef.current = null;

    whenReady(() => {
      CoreEvent.emit(eventNames.composer.open, { question, source: 'page' });
    });
  }, [targetQuestion, whenReady]);

  return (
    <div
      className="flex shrink-0 items-center gap-sm"
      data-testid="home-starter-question"
    >
      <span className="text-text-strong t-label-sm">Get started</span>
      <AiSuggestionChip
        aria-busy={isPending}
        aria-label={targetQuestion}
        data-analytics-attributes={JSON.stringify({ question: targetQuestion })}
        data-analytics-id="Composer - Starter Question"
        data-testid="home-starter-question-chip"
        disabled={isPending}
        iconLeft={false}
        label={displayedText}
        onClick={handleClick}
        onPointerDown={handlePointerDown}
        testId="home-starter-question-chip"
      />
    </div>
  );
}
